<div *ngIf="showToast" class="toggle-all-toast-overlay">
  <div class="toast-container">
    <ion-icon
      name="information-circle-outline"
      data-cy="toast-container-icon"
    ></ion-icon>
    <span class="toast-message" data-cy="toast-messsage-text">
      {{ toastMessage | translate }}
    </span>
    <ion-icon
      name="close-circle-outline"
      class="toast-dismiss-button-icon"
      data-cy="toast-dismiss-button-icon"
      (click)="onClose()"
    ></ion-icon>
  </div>
  <ion-item lines="none" class="toast-dont-show-again-checkbox">
    <ion-checkbox
      mode="ios"
      slot="start"
      data-cy="toast-dont-show-again-checkbox"
      (ionChange)="onDontShowAgainChange($event)"
    ></ion-checkbox>
    <ion-label>{{
      'i18n.notifications.preferences.doNotShowAgain' | translate
    }}</ion-label>
  </ion-item>
</div>
